export default `#version 300 es
precision highp float;
#define GLSLIFY 1

in vec2 uv;
in vec3 position;
in vec3 normal;

out vec3 vNormal;
out vec3 worldPosition;
out float vFragDepth;

uniform mat4 modelMatrix;
uniform mat4 viewMatrix;
uniform mat4 projectionMatrix;

void main() {
    vec4 mPosition = modelMatrix * vec4(position, 1.0f);
    worldPosition = mPosition.xyz;

    vNormal = mat3(modelMatrix) * normal;

    gl_Position = projectionMatrix * viewMatrix * mPosition;
    vFragDepth = 1.f + gl_Position.w;
}`